import React from 'react';
import PropTypes from 'prop-types';
import './Tile.css';

const Tile = ({ instrumentName, instrumentData, isExpanded, toggleTile }) => {
  if (!instrumentData) return null;

  const { current_data, data_24h_ago, long_change, short_change, error } = instrumentData;

  const isLongLarger = long_change > short_change;
  const difference = Math.abs(long_change - short_change); // Unterschied zwischen den Werten

  if (error) {
    return (
      <div className="tile" key={instrumentName}>
        <div className="tile-title">{instrumentName.toUpperCase()}</div>
        <div className="tile-error">Error: {error}</div>
      </div>
    );
  }

  return (
    <div
      className={`tile ${isExpanded ? 'expanded' : ''}`}
      key={instrumentName}
      onClick={() => toggleTile(instrumentName)}
      role="button"
      tabIndex={0}
      onKeyPress={(e) => {
        if (e.key === 'Enter') toggleTile(instrumentName);
      }}
      aria-expanded={isExpanded}
      aria-controls={`details-${instrumentName}`}
    >
      <div className="tile-title">{instrumentName.toUpperCase()}</div>
      <div className="tile-change-container">
        <div
          className={`tile-change ${
            isLongLarger && difference > 4 ? 'bigger' : difference > 4 ? 'smaller' : ''
          }`}
        >
          Long: {long_change}%
        </div>
        <div
          className={`tile-change ${
            !isLongLarger && difference > 4 ? 'bigger' : difference > 4 ? 'smaller' : ''
          }`}
        >
          Short: {short_change}%
        </div>
      </div>

      <div
        id={`details-${instrumentName}`}
        className="tile-details"
        aria-hidden={!isExpanded}
      >
        <div className="detail-section">
          <h4>Current Data</h4>
          <div className="detail">Long: {current_data.long}%</div>
          <div className="detail">Short: {current_data.short}%</div>
          <div className="detail">Timestamp: {new Date(current_data.timestamp).toLocaleString()}</div>
        </div>
        <div className="detail-section">
          <h4>Data from 24 Hours Ago</h4>
          <div className="detail">Long: {data_24h_ago.long}%</div>
          <div className="detail">Short: {data_24h_ago.short}%</div>
          <div className="detail">Timestamp: {new Date(data_24h_ago.timestamp).toLocaleString()}</div>
        </div>
      </div>
    </div>
  );
};

Tile.propTypes = {
  instrumentName: PropTypes.string.isRequired,
  instrumentData: PropTypes.object,
  isExpanded: PropTypes.bool.isRequired,
  toggleTile: PropTypes.func.isRequired,
};

export default React.memo(Tile);
